import {
  createSha256,
  decodeAuthenticationResponse,
  decodeSeedResponse,
  decodeUnlockResponse,
  encodeAuthenticationRequest,
  encodeSeedRequest,
  encodeUnlockRequest,
  initState,
  peripheralExtractId,
  waitFor,
} from './sclak.js';

// Exposed BLE service to write
const toWrite = {
  service: '25e1452d-6402-4182-9aaa-c64936b7c487',
  characteristic: '00000000-0000-002b-504c-554747010000',
};

// Exposed BLE service to read
const toRead = {
  service: '25e1452d-6402-4182-9aaa-c64936b7c487',
  characteristic: '00000000-0000-002b-504c-554747020000',
};

const unlockDevice = async (id, secretCode) => {
  const MAX_RETRIES = 24;
  let success = false;
  for (let i = 0; i < MAX_RETRIES && !success; i++) {
    try {
      const device = await navigator.bluetooth.requestDevice({
        filters: [{ namePrefix: 'Sclak' }],
        optionalServices: [toWrite.service, toRead.service],
      });
      const server = await device.gatt.connect();
      const services = await server.getPrimaryServices();
      const characteristics = await Promise.all(services.map((s) => s.getCharacteristics())).then((cs) => cs.flat());
      const peripheral = {
        id: peripheralExtractId(device, 'web'),
        name: device.name,
        toWrite: characteristics.find((c) => c.uuid === toWrite.characteristic),
        toRead: characteristics.find((c) => c.uuid === toRead.characteristic),
        secretCode,
      };
      const sha256 = await createSha256();
      let state = initState(peripheral, sha256, peripheral.secretCode);
      state = await doSeed(state);
      state = await doAuthenticate(state);
      await doUnlock(state);
      await device.gatt.disconnect();
      success = true;
    } catch (e) {
      console.error(e);
    }
  }
};

const doSeed = async (state) => doCommand(state, encodeSeedRequest, decodeSeedResponse);

const doAuthenticate = async (state) => doCommand(state, encodeAuthenticationRequest, decodeAuthenticationResponse);

const doUnlock = async (state) => doCommand(state, encodeUnlockRequest, decodeUnlockResponse);

const doCommand = async (beforeState, encode, decode) => {
  const { state, req } = encode(beforeState);
  const toWrite = new Uint8Array(req);
  await state.peripheral.toWrite.writeValueWithResponse(toWrite);
  await waitFor(200);
  const fromRead = await state.peripheral.toRead.readValue();
  const res = [...new Uint8Array(fromRead.buffer)];
  return decode(state, res);
};

export default unlockDevice;
